// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"516dbc6f","315":"9ea22550","618":"63272794"}[chunkId] + ".chunk.css";
};